import { render, staticRenderFns } from "./MainSubMenu.vue?vue&type=template&id=183b8939&scoped=true"
import script from "./MainSubMenu.vue?vue&type=script&lang=js"
export * from "./MainSubMenu.vue?vue&type=script&lang=js"
import style0 from "./MainSubMenu.vue?vue&type=style&index=0&id=183b8939&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b8939",
  null
  
)

export default component.exports